import styled from 'styled-components'

export const StyledDragable = styled.div`
	cursor: pointer;
	display: flex;
    align-items: center;
    padding: 3px 0;
    > div {
    	margin-bottom: 0 !important;
    	width: 100%;
    }

`

export const StyledModalContainer = styled.div`
	text-align: justify;
`